import React, { useState, useEffect } from 'react';
// import axios from 'axios'; // removido
import api from '../../api/axiosConfig'; // adicionado
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Table, Tabs, Pagination } from 'antd';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import '../Css/AnaliseComponente.css';
import { 
  LineChartOutlined, 
  BarChartOutlined, 
  PieChartOutlined, 
  AreaChartOutlined, 
  BulbOutlined, 
  MenuOutlined 
} from '@ant-design/icons';

const AnaliseParImpar = () => {
  const navigate = useNavigate();

  // Aba 1: Dados de estatistica_atraso_rep_par_impar (separado em impar e par)
  const [repData, setRepData] = useState({});
  // Aba 3: Dados de estatistica_atraso_par_impar (separado em impar e par)
  const [atrasoData, setAtrasoData] = useState({});

  // Outros estados
  const [frequeData, setFrequeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeKey, setActiveKey] = useState("1");

  // Página atual para a Aba 1 (1 = ímpar, 2 = par)
  const [currentRepPage, setCurrentRepPage] = useState(1);
  // Página atual para a Aba 3 (1 = ímpar, 2 = par)
  const [currentAtrasoPage, setCurrentAtrasoPage] = useState(1);

  // Alerta de carregamento
  useEffect(() => {
    if (loading) {
      Swal.fire({
        title: 'Carregando...',
        text: 'Estamos processando as informações.',
        icon: 'info',
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
    }
  }, [loading]);

  // Carregar os dados da API
  useEffect(() => {
    // Aba 1: Estatística de atraso rep par/impar
    api.get(`${process.env.REACT_APP_API_URL}/estatistica_atraso_rep_par_impar`)
      .then(response => {
        setRepData(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Erro ao buscar os dados de rep par/impar:", error);
        setLoading(false);
        Swal.fire({
          title: 'Erro!',
          text: 'Não foi possível carregar os dados de Análise (rep par/impar).',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      });
  
    // Aba 2: Frequência par/impar
    api.get(`${process.env.REACT_APP_API_URL}/freque_par_impar`)
      .then(response => {
        setFrequeData(response.data || []);
      })
      .catch(error => {
        console.error("Erro ao buscar os dados de frequência par/impar:", error);
        setFrequeData([]);
        Swal.fire({
          title: 'Erro!',
          text: 'Não foi possível carregar os dados de Frequência (par/impar).',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      });
  
    // Aba 3: Estatística de atraso par/impar
    api.get(`${process.env.REACT_APP_API_URL}/estatistica_atraso_par_impar`)
      .then(response => {
        setAtrasoData(response.data);
      })
      .catch(error => {
        console.error("Erro ao buscar os dados de atraso par/impar:", error);
        setAtrasoData({});
        Swal.fire({
          title: 'Erro!',
          text: 'Não foi possível carregar os dados de Dezenas sorteadas (par/impar).',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      });
  }, []);
  
  // Fechar o alerta de carregamento depois que os dados forem carregados
  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        Swal.close();
      }, 1500);
    }
  }, [loading]);
  
  const onTabChange = (key) => {
    setActiveKey(key);
  };

  const repImparArray = repData.estatistica_atraso_rep_impar || [];
  const repParArray = repData.estatistica_atraso_rep_par || [];

  const displayedRepData = currentRepPage === 1 ? repImparArray : repParArray;

  const atrasoImparArray = atrasoData.estatistica_atraso_impar || [];
  const atrasoParArray = atrasoData.estatistica_atraso_par || [];

  const displayedAtrasoData = currentAtrasoPage === 1 ? atrasoImparArray : atrasoParArray;

  const repColumns = [
    { title: 'Dezenas', dataIndex: 'repetido', key: 'repetido' },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { title: '%', dataIndex: 'percente', key: 'percente', render: text => `${text} %` },
    { title: 'Média Sorteio', dataIndex: 'mdSorteio', key: 'mdSorteio' },
    { 
      title: 'Atrasados', 
      dataIndex: 'atrasados', 
      key: 'atrasados',
      render: (text, record) => (
        <span className={record.atrasados > record.mdSorteio ? 'highlight-high' : ''}>
          {text}
        </span>
      )
    },
    { 
      title: 'Status Jogos', 
      dataIndex: 'pj', 
      key: 'pj',
      render: text => (
        <span className={text === 'Melhor Opção!' ? 'melhor-opcao' : ''}>
          {text}
        </span>
      )
    }
  ];

  const frequeColumns = [
    { title: 'Dezenas', dataIndex: 'dezenas', key: 'dezenas' },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { 
      title: '%', 
      dataIndex: 'percente', 
      key: 'percente', 
      render: text => `${text} %` 
    },
    { 
      title: 'Frequência', 
      dataIndex: 'freqAcu', 
      key: 'freqAcu',
      render: text => `${text} - JG`
    },
    { 
      title: 'Frequência AC', 
      dataIndex: 'freqAcmlda', 
      key: 'freqAcmlda',
      render: text => `${text} %`
    }
  ];

  const atrasoColumns = [
    { title: 'Numeros', dataIndex: 'dezenas', key: 'dezenas' },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { 
      title: '%', 
      dataIndex: 'percente', 
      key: 'percente', 
      render: text => `${text} %` 
    },
    { title: 'Média Sorteio', dataIndex: 'mdSorteio', key: 'mdSorteio' },
    { 
      title: 'Atrasados', 
      dataIndex: 'atrasados', 
      key: 'atrasados',
      render: (text, record) => (
        <span className={record.atrasados > record.mdSorteio ? 'highlight-high' : ''}>
          {text}
        </span>
      )
    },
    { 
      title: 'Status Jogos', 
      dataIndex: 'pj', 
      key: 'pj', 
      render: text => (
        <span className={text === 'Melhor Opção!' ? 'melhor-opcao' : ''}>
          {text}
        </span>
      )
    }
  ];

  const repChartData = displayedRepData.map(item => ({
    name: `${item.repetido} - Dz`,
    quantidade: item.qte,
    percentual: item.percente,
  }));

  const frequeChartData = frequeData.map(item => ({
    name: item.dezenas,
    quantidade: item.qte,
    percentual: item.percente,
    frequencia: item.freqAcu,
    frequenciaAc: item.freqAcmlda,
  }));

  const atrasoChartData = displayedAtrasoData.map(item => ({
    name: `Nu - ${item.dezenas}`,
    quantidade: item.qte,
    percentual: item.percente,
  }));

  const tabsItems = [
    {
      label: <LineChartOutlined className="icon-size-24" />,
      key: "1",
      children: (
        <div>
          <h2><span>Análise - Ímpar-Par</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart width={500} height={400} data={repChartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" scale="band" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantidade" barSize={50} fill="#007AA2" />
              <Line type="monotone" dataKey="percentual" stroke="#ff7300" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table 
              columns={repColumns} 
              dataSource={displayedRepData} 
              loading={loading} 
              rowKey="id" 
              pagination={false} 
            />
          </div>

          {/* Paginação de 2 páginas: 1 = Ímpar, 2 = Par */}
          <Pagination
            current={currentRepPage}
            total={2} // somente 2 páginas
            pageSize={1}
            onChange={(page) => setCurrentRepPage(page)}
            style={{ marginTop: 16, textAlign: 'center' }}
            itemRender={(page, type, originalElement) => {
              if (type === 'page') {
                return <a>{page === 1 ? 'Ímpar' : 'Par'}</a>;
              }
              return originalElement;
            }}
          />
        </div>
      )
    },
    {
      label: <BarChartOutlined className="icon-size-24" />,
      key: "2",
      children: (
        <div>
          <h2><span>Frequência - Ímpar-Par</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart width={500} height={400} data={frequeChartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" scale="band" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantidade" stackId="a" barSize={50} fill="#004B57" />
              <Bar dataKey="percentual" stackId="a" barSize={50} fill="#ff7300" />
              <Bar dataKey="frequencia" stackId="a" barSize={50} fill="#007AA2" />
              <Bar dataKey="frequenciaAc" stackId="a" barSize={50} fill="#008DC0" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table 
              columns={frequeColumns} 
              dataSource={frequeData} 
              loading={loading} 
              rowKey="id" 
              pagination={false} 
            />
          </div>
        </div>
      )
    },
    {
      label: <AreaChartOutlined className="icon-size-24" />,
      key: "3",
      children: (
        <div>
          <h2><span>Dezenas - Ímpar-Par</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart width={500} height={400} data={atrasoChartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" scale="band" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantidade" barSize={50} fill="#007AA2" />
              <Line type="monotone" dataKey="percentual" stroke="#ff7300" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table 
              columns={atrasoColumns} 
              dataSource={displayedAtrasoData} 
              loading={loading} 
              rowKey="id" 
              pagination={false} 
            />
          </div>

          {/* Paginação de 2 páginas: 1 = Ímpar, 2 = Par */}
          <Pagination
            current={currentAtrasoPage}
            total={2} // somente 2 páginas
            pageSize={1}
            onChange={(page) => setCurrentAtrasoPage(page)}
            style={{ marginTop: 16, textAlign: 'center' }}
            itemRender={(page, type, originalElement) => {
              if (type === 'page') {
                return <a>{page === 1 ? 'Ímpar' : 'Par'}</a>;
              }
              return originalElement;
            }}
          />
        </div>
      )
    },
    {
      label: <BulbOutlined className="icon-size-24" />,
      key: "4",
      children: (
        <div>
          <h2><span>Ideias Dz - Ímpar-Par</span></h2>
        </div>
      )
    },
    {
      label: <MenuOutlined className="icon-size-24" onClick={() => navigate("/dashboard")} />,
      key: "5",
    }
  ];
  
  return (
    <div className="analysis-container">
      <Tabs activeKey={activeKey} onChange={onTabChange} tabPosition={"right"} items={tabsItems} />
    </div>
  );
};

export default AnaliseParImpar;
